type Props = {
  preview?: string;
};

const AdminKeysSecretsCredentialValue = ({ preview }: Props) => (
  <code
    data-dd-privacy="mask"
    className="block break-all px-2 py-1 font-mono text-xs text-[#1F2D2A] dark:bg-gray-800 dark:text-gray-400"
  >
    {preview ?? "Missing"}
  </code>
);

export default AdminKeysSecretsCredentialValue;
